<div class="price-card-wrapper position-relative">
  @if (isSelected) {
    <div class="badge rounded-pill bg-info recommended-product">{{ 'base_price_card_selected' |i18next}}</div>
  }
  <div class="price-card card card-nb h-100" [ngClass]="getCssClasses()">
    <div class="d-flex flex-column h-100">
      <div class="price-card-header">
        <div class="d-flex align-items-center flex-column">
          <div class="subscription-type h3">{{ name | i18next }}</div>
          <div class="subscription-price mt-auto">
            <span class="price">
              {{ formattedPricePrefix }} {{ price | localized_currency }}*
            </span>
          </div>
          <span class="time-billing">{{ timeBilling | i18next }}</span>
        </div>
      </div>

      <div class="price-card-body">
        <ng-content></ng-content>
      </div>
      <div class="mt-auto mb-4">
        <button class="btn btn-primary bg-transparent text-danger " (click)="select()"
        [class.invisible]="isSelected && !showSelectButton" [disabled]="isSelected && !showSelectButton">
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</div>
